import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { IconButton } from '@/components/IconButton';
import type { BreakpointsKeys } from '@/theme/types';

export const Wrapper = styled(Box)<{
  $height?: string;
  $maxWidth: BreakpointsKeys;
  $overflowHidden: boolean;
  $width?: string;
  gutters: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;

  ${({
    $height,
    $maxWidth,
    $overflowHidden,
    $width,
    gutters,
    theme,
    theme: { maxWidth, media },
  }) => css`
    background-color: ${theme.colors.white};
    padding-block: ${theme.spacing(3, 4)};

    ${gutters &&
    css`
      padding-inline: ${theme.spacing(3)};
    `}

    ${$maxWidth &&
    css`
      ${media[$maxWidth].up} {
        max-width: ${maxWidth[$maxWidth]};
      }
    `}
 
    //TODO Old code built on top of bugs, affects too many components, please refactor if have chance
    margin-inline: ${theme.spacing(2)};

    ${$width &&
    css`
      width: ${$width};
      height: fit-content;
    `}

    ${$height &&
    css`
      height: ${$height};
    `}

    ${theme.media.sm.up} {
      height: fit-content;
      max-height: 96%;
    }

    ${$overflowHidden &&
    css`
      overflow: hidden;
    `}
  `};
`;

export const Header = styled.header`
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h4};
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.components.modal.header.color};

    ${theme.media.sm.up} {
      font-size: ${theme.fontSizes.h3Mobile};
    }
  `}
`;

export const Divider = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.colors.mediumGrey};
`;

export const Close = styled(IconButton)`
  position: absolute;
  right: 0;
  top: 0;
  width: 14px;
  height: 14px;
  color: ${({ theme }) => theme.colors.black};

  ${({ theme }) => css`
    margin: ${theme.space.s080} ${theme.space.s120};
  `}
`;

export const Body = styled(Box)`
  font-size: ${({ theme }) => theme.fontSizes.p2};
  ${({ theme }) => css`
    ${theme.media.sm.up} {
      overflow: auto;
    }
  `}
`;

export const Footer = styled.footer<{ isFullWidthMobile: boolean }>`
  display: flex;
  flex-direction: column;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
  &::-webkit-scrollbar {
    display: none;
  }
  ${({ isFullWidthMobile, theme }) => css`
    ${theme.media.sm.down} {
      background-color: ${theme.colors.white};
      position: fixed;
      inset: auto 0 0 0;
      z-index: ${theme.zIndex.modalFixedFooter};
    }

    ${!isFullWidthMobile &&
    css`
      position: relative !important;
    `}
  `}
`;

export const TailWrapper = styled(Box)`
  ${({ theme }) => css`
    background: ${theme.colors.primary};
  `}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const Tail = styled(Box)`
  ${({ theme }) => css`
    height: ${theme.components.modal.tail.height};
    background: ${theme.components.modal.tail.background};
  `}
  width: 100%;
`;
